export default __webpack_public_path__ + "static/media/vid.21a4dfff.mp4";